var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReplay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1573_27151)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9817 4.18034C10.7847 2.98327 9.19303 2.324 7.50011 2.324H6.5709L8.06231 0.828926L7.23134 0L4.32667 2.91179L7.19343 5.82647L8.03023 5.00344L6.54925 3.4977H7.50011C10.3477 3.4977 12.6644 5.81437 12.6644 8.662C12.6644 11.5096 10.3477 13.8263 7.50011 13.8263C4.65251 13.8263 2.3358 11.5096 2.3358 8.66188V8.07504L1.16211 8.07516V8.662C1.16211 10.355 1.82138 11.9466 3.01848 13.1436C4.21555 14.3407 5.80719 15 7.50011 15C9.19303 15 10.7847 14.3407 11.9817 13.1436C13.1788 11.9465 13.8381 10.3549 13.8381 8.662C13.8381 6.96908 13.1788 5.37744 11.9817 4.18034Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1573_27151"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplay);
export default __webpack_public_path__ + "static/media/Replay.c989ed3a953fccded542edd16ba8f948.svg";
export { ForwardRef as ReactComponent };